// extracted by mini-css-extract-plugin
export default {"top":"ConversionModal_top__iciPC","two_items":"ConversionModal_two_items__TyAbD","currency_info":"ConversionModal_currency_info__MMZDT","cur_det":"ConversionModal_cur_det__lMtlp"};